module.exports = __webpack_public_path__ + "static/media/coding.61e3a393.jpg";